import { useCallback } from 'react';
import { selectUser, useAuthStore } from '@/store';

const usePermission = () => {
	const user = useAuthStore(selectUser);
	const permissions = user?.userInformation.permissions;

	const hasPermission = useCallback(
		(permissionsToCheck: string[]) => {
			return permissionsToCheck.some((permission) =>
				permissions?.includes(permission),
			);
		},
		[permissions],
	);

	return { hasPermission };
};

export default usePermission;
